export default {"src":"/_next/static/media/StarklingsDeerLogo.6fda945c.svg","height":87,"width":97};